import { Outlet } from 'react-router-dom';

import PrivateRoute from 'routing/PrivateRoute';

const NoCardRouteLayout = () => {
  return <PrivateRoute element={<Outlet />} />;
};
export default NoCardRouteLayout;
